import React, { useState, useEffect, useRef } from "react";
import TableAdminSection from './TableAdminSection';
import AnalyticsComponent from "./admin-components/analyticsComponent";
import UserAdministrationComponent from "./admin-components/userAdministrationComponent";
import AllUserAdministrationComponent from "./admin-components/AllUseradminstration";
import CustomerAdministrationComponent from "./admin-components/customerAdministrationComponent";
import TableAdministrationComponent from "./admin-components/tableAdministrationComponent";
import BillableEvent from "./admin-components/BillableEvent"
const CODAdmin = () => {
  return (
    <div className="dashboard">
        <AnalyticsComponent />
        <BillableEvent />
        <UserAdministrationComponent />
        <br />
        <AllUserAdministrationComponent />
        <br />
        <CustomerAdministrationComponent />
        <br />
        <TableAdministrationComponent />
        <br />
        
    </div>
  )
};


export default CODAdmin;